import { onCLS, onFID, onFCP, onLCP, onTTFB, type Metric } from 'web-vitals';
import { logger } from '@/utils/logger';

type ReportHandler = (metric: Metric) => void;

const reportWebVitals = (onReport?: ReportHandler) => {
  const handler = onReport || logToConsole;

  onCLS(handler);
  onFID(handler);
  onFCP(handler);
  onLCP(handler);
  onTTFB(handler);
};

function logToConsole(metric: Metric) {
  if (process.env.NODE_ENV === 'development') {
    logger.debug(`[Web Vitals] ${metric.name}: ${metric.value.toFixed(2)}`);
  }
}

// Send to analytics endpoint (production)
export function sendToAnalytics(metric: Metric) {
  const body = JSON.stringify({
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    delta: metric.delta,
    id: metric.id,
    navigationType: metric.navigationType,
  });

  // Use sendBeacon for reliability, fallback to fetch
  if (navigator.sendBeacon) {
    navigator.sendBeacon('/api/v1/analytics/web-vitals', body);
  } else {
    fetch('/api/v1/analytics/web-vitals', {
      method: 'POST',
      body,
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
    }).catch(() => {
      // Silently fail - analytics should never break the app
    });
  }
}

export default reportWebVitals;
